<mat-dialog-content style="min-width:800px">

  <t4-container title="{{'T4.Campaigns.Campaign.Createtvoucherstitle' |translate : 'Create vouchers' }}">

    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblamountofvouchers' |translate : 'Amount of vouchers to create' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipvalue2' | translate : 'The monetary value of this discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input [disabled]="!campaign.CanEdit" type="text" [(ngModel)]="counter" [formControl]="voutherscount" matInput value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblcooperationwith' |translate : 'Cooperation with' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipvalue2' | translate : 'The monetary value of this discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input [disabled]="!campaign.CanEdit" type="text" [(ngModel)]="partner" matInput value="" />
        </mat-form-field>
      </div>
    </div>



    <div class="row settingRow" style="margin-top:10px;">
      <div class="col-3" style="text-align:right; top:20px;"></div>
      <div class="col-9">
        <mat-radio-group [(ngModel)]="valueType">
          <mat-radio-button [value]="0" [disabled]="!campaign.CanEdit" #rdbPercent style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</mat-radio-button>
          <mat-radio-button [value]="1" [disabled]="!campaign.CanEdit" #rdbValue style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblamount' |translate : 'Amount' }}</mat-radio-button>
          <mat-radio-button [value]="2" [disabled]="!campaign.CanEdit" #rdbTime>{{'T4.Campaigns.createCampaign.lblHours' |translate : 'Hours' }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row settingRow" *ngIf="rdbPercent.checked">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tippercent2' | translate : 'The percentual value of this discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="number" [formControl]="procentValue" [(ngModel)]="value" #txtpercent matInput />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errercentageexpression' | translate : 'Percentage can only contain numbers and be between 1 and 100' }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow" *ngIf="rdbValue.checked">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblvalue' |translate : 'Value' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipvalue2' | translate : 'The monetary value of this discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="number" [formControl]="amountValue" [(ngModel)]="value" #amount matInput #txtValue />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow" *ngIf="rdbTime.checked">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblTime' |translate : 'Hours' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipHours' | translate : 'The number of hours to discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="number" autocomplete="off" [(ngModel)]="value" [formControl]="timeValue" #txtTime matInput />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
        </mat-form-field>
      </div>
    </div>

  </t4-container>
  <div style="margin-top: 30px; text-align: center;">
    <button class="btn btn-default" [disabled]="voutherscount.errors ||
            (amountValue.errors && valueType == 1) ||
            (procentValue.errors && valueType == 0) ||
            (timeValue.errors && valueType ==  2)" mat-raised-button color="primary" type="button" (click)="generateVouchers()" style="margin-left: 10px;" *ngIf="campaign?.IsTemplate && campaign?.GenerationPattern == 0"><mat-icon>directions_run</mat-icon>&nbsp;{{ 'T4.Campaign.createCampaign.lblgeneratevouchers' | translate : 'Generate Vouchers'}}</button>
  </div>
</mat-dialog-content>
